export class AddAdministratorDto {
    email!: string;
    name!: string;
    phone: string;
    password: string;
    imageUrl: string;
    position: string;
}